module.exports = __webpack_public_path__ + "img/brands-barilla-reverse.jpg?d3ddc460272213d8265828d70ba4f71e";